import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext';
import LandingAdvantages from './components/LandingAdvantages';
import LandingCalculator from './components/LandingCalculator';
import LandingContactDialog from './components/LandingContactDialog';
import LandingFooter from './components/LandingFooter';
import LandingHeader from './components/LandingHeader';
import LandingHero from './components/LandingHero';
import LandingIncomeHelpDialog from './components/LandingIncomeHelpDialog';
import LandingNetwork from './components/LandingNetwork';
import LandingPartnerTypes from './components/LandingPartnerTypes';
import LandingPlanHelpDialog from './components/LandingPlanHelpDialog';
import LandingPlans from './components/LandingPlans';
import LandingPremium from './components/LandingPremium';
import { LandingGlobalStyled } from './styled/LandingGlobalStyled';

const LandingPageStyled = styled.div``;

function LandingPage() {
    const { hash } = useLocation();
    const { getLangPath, locale } = useLangContext();
    const [contactOpen, setContactOpen] = useState(false);
    const [planHelpOpen, setPlanHelpOpen] = useState(false);
    const [incomeHelpOpen, setIncomeHelpOpen] = useState(false);
    const openContact = useCallback(() => setContactOpen(true), []);
    const closeContact = useCallback(() => setContactOpen(false), []);
    const openPlanHelp = useCallback(() => setPlanHelpOpen(true), []);
    const closePlanHelp = useCallback(() => setPlanHelpOpen(false), []);
    const openIncomeHelp = useCallback(() => setIncomeHelpOpen(true), []);
    const closeIncomeHelp = useCallback(() => setIncomeHelpOpen(false), []);

    useEffect(() => {
        const root = document.documentElement;
        const previousBehavior = root.style.scrollBehavior;
        const previousPadding = root.style.scrollPaddingTop;
        const media = window.matchMedia('(prefers-reduced-motion: reduce)');
        const applyScroll = () => {
            root.style.scrollBehavior = media.matches ? 'auto' : 'smooth';
            root.style.scrollPaddingTop = '25px';
        };
        applyScroll();
        media.addEventListener('change', applyScroll);
        return () => {
            media.removeEventListener('change', applyScroll);
            root.style.scrollBehavior = previousBehavior;
            root.style.scrollPaddingTop = previousPadding;
        };
    }, []);

    useEffect(() => {
        if (!locale) return undefined;
        const previousTitle = document.title;
        document.title = getLangPath('landing.meta.title');
        return () => {
            document.title = previousTitle;
        };
    }, [getLangPath, locale]);

    useEffect(() => {
        if (!hash) return;
        const target = document.getElementById(hash.slice(1));
        if (target) target.scrollIntoView();
    }, [hash]);

    return (
        <LandingPageStyled className="jetvix-landing" lang={locale || 'en'}>
            <LandingGlobalStyled/>
            <LandingHeader/>
            <main>
                <LandingHero onOpenContact={openContact}/>
                <LandingPartnerTypes onOpenContact={openContact}/>
                <LandingPlans onOpenContact={openContact} onOpenPlanHelp={openPlanHelp}/>
                <LandingNetwork/>
                <LandingCalculator onOpenIncomeHelp={openIncomeHelp}/>
                <LandingAdvantages/>
                <LandingPremium onOpenContact={openContact}/>
            </main>
            <LandingFooter/>
            <LandingContactDialog open={contactOpen} onClose={closeContact}/>
            <LandingPlanHelpDialog open={planHelpOpen} onClose={closePlanHelp}/>
            <LandingIncomeHelpDialog open={incomeHelpOpen} onClose={closeIncomeHelp}/>
        </LandingPageStyled>
    );
}

export default LandingPage;
